import constants from '@/shared/constants/constants';
import GenerationHistoryListItemConcept from '../list/GenerationHistoryListItemConcept.vue';
import GenerationHistoryListItemDesign from '../list/GenerationHistoryListItemDesign.vue';
import GenerationHistoryListItemNaming from '../list/GenerationHistoryListItemNaming.vue';

export function getListItemComponent(projectType) {
  if (projectType === constants.PROJECT_GENERATE_CONCEPT) {
    return GenerationHistoryListItemConcept;
  }
  if (projectType === constants.PROJECT_CHAT_GPT) {
    return GenerationHistoryListItemNaming;
  }
  if (projectType === constants.PROJECT_GENERATE_IMAGE) {
    return GenerationHistoryListItemDesign;
  }
  return GenerationHistoryListItemConcept;
}
